module.exports = __webpack_public_path__ + "img/tiktok_white.1b3704cb.png";